import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { ConfigDTO } from "../../../../common/types/ConfigDTO";

// Bootstrap service: fetched before auth and before runtime config exists,
// so it cannot use `createServiceBaseQuery` (which reads URLs from this very
// config). Hits the BFF directly via the relative `/v2` path; no auth header
// because the BFF allows unauthenticated config reads.
export const configService = createApi({
  reducerPath: "configService",
  baseQuery: fetchBaseQuery({ baseUrl: "/v2" }),
  tagTypes: ["Config"],
  endpoints: (builder) => ({
    getConfig: builder.query<ConfigDTO, void>({
      query: () => `api/config`,
      providesTags: [{ type: "Config", id: "LIST" }],
    }),
  }),
});

export const { useGetConfigQuery } = configService;
